import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../contexts/PermissionContext';
import { canAccessPath } from '../config/routePermissions';

/**
 * Permission Route Component
 *
 * Dozvoljava pristup ruti samo ako korisnik ima BILO KOJU od dozvola
 * definisanih za tu putanju. Ako nema nijednu -> redirect na /403.
 *
 * Ovo je SAMO UX sloj - backend i dalje vraća 403 na svaki endpoint.
 *
 * @param {string} path - Putanja rute (ključ u ROUTE_PERMISSIONS)
 * @param {React.Component} children - Komponenta koja se renderuje ako je dozvoljeno
 */
const PermissionRoute = ({ path, children }) => {
  const { canAny, permissions, isAdmin, loading } = usePermissions();

  // Dok se dozvole učitavaju, ne odlučujemo (izbegavamo FOUC / lažni 403).
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          minHeight: '40vh',
          fontSize: '1.2rem',
          color: '#666',
        }}
      >
        Učitavanje...
      </div>
    );
  }

  if (!canAccessPath(path, { canAny, permissions, isAdmin })) {
    return <Navigate to="/403" replace />;
  }

  return children;
};

export default PermissionRoute;
